import { createFileRoute } from '@tanstack/react-router'
import { JournalDetailPage } from '../../../features/accounting/journal-detail-page'
import { journalQueryOptions } from '../../../features/accounting/queries'

export const Route = createFileRoute('/_app/journal-entries/$entryId')({
  staticData: { crumb: 'journal' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(journalQueryOptions(params.entryId)),
  component: JournalDetailPage,
})
